import { MouseEvent } from 'react';

import { MenuItem } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useChatContext } from 'features/chat/context/chat';
import { useToggleChatReadStatusMutation } from 'features/chat/hooks/mutation/useToggleChatReadStatus';

export const ChatHeaderMenuToggleChatReadStatusOption = () => {
  const { isChatMarkedAsUnread } = useChatContext();

  const { mutateAsync: toggleChatReadStatus } =
    useToggleChatReadStatusMutation();

  const handleToggleChatReadStatus = (evt: MouseEvent) => {
    evt.stopPropagation();

    toggleChatReadStatus();
  };

  return (
    <MenuItem onClick={handleToggleChatReadStatus}>
      <Icon
        name={
          isChatMarkedAsUnread
            ? iconNames.chat
            : iconNames.chatWithUnreadIndicator
        }
      />{' '}
      {`Mark as ${isChatMarkedAsUnread ? 'read' : 'unread'}`}
    </MenuItem>
  );
};
